import { API_URL_MAIN } from '@/config';
import { axios } from '@/lib/axios';

export const ApiGetUserNameInfo = () => {
    return axios.get(`${API_URL_MAIN}/authorize/get_user_name_info`,
    );
};
